import { APP_ROUTES } from '@ps/core-config';

const OPERATOR_ONLY_ROUTES: readonly string[] = [
  '/users/buyer-service-account/token',
  '/variable-margin/',
  '/multi-surveys/',
  '/getBuyers',
  '/comments',
  '/notification-center/mentionable-users',
];

const BUYER_CONTEXT_PAGES: readonly string[] = [
  APP_ROUTES.DASHBOARD,
  APP_ROUTES.RECONTACT_SURVEY,
  '/surveys',
];

export class RouteContext {
  public constructor(
    private readonly _routeUrl: string,
    private readonly _pageUrl: string,
  ) {}

  public requiresImpersonatedBuyerToken(): boolean {
    return !this._isOperatorOnlyRoute() && this._isBuyerContextPage();
  }

  private _isOperatorOnlyRoute(): boolean {
    return OPERATOR_ONLY_ROUTES.some((route) => this._routeUrl.includes(route));
  }

  private _isBuyerContextPage(): boolean {
    return BUYER_CONTEXT_PAGES.some((page) => this._pageUrl.startsWith(page));
  }
}
